import Vue from "vue";
import Router from "vue-router";
import Main from "./views/Main.vue";
import BookDetail from "./views/BookDetail.vue";
import Webview from "./views/WebView.vue";
import Catalog from "./views/pdf.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "bims",
      component: Main
    },
    {
      path: "/bookdetail",
      name: "bookdetail",
      component: BookDetail
    },
    {
      path: "/search",
      name: "search",
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/SearchBook.vue")
    },
    {
      path: "/webview",
      name: "webview",
      component:Webview
    },
    {
      path: "/catalog",
      name: "catalog",
      component:Catalog
    }
  ]
});

export default router;
